module.exports = __webpack_public_path__ + "img/Pic_Title_QGPJYDNLFX.0959b6f1.png";